import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpResponse } from '@angular/common/http';
import { HttpRequest } from '@angular/common/http';
import { HttpHandler } from '@angular/common/http';
import { HttpEvent } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import {IsfViewSpinnerService} from "./isf.view.spinner";



@Injectable()
export class IsfViewHttpInterceptor implements HttpInterceptor {
	
	private uri = [
		"io/isf"
	];
	
	
	
	constructor(private spinnerService: IsfViewSpinnerService) { }

	
	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		
		if(this.uri.find(u => req.url.includes(u))){

			this.spinnerService.show();
			
			return next.handle(req).pipe(tap((event: HttpEvent<any>) => {
					if(event instanceof HttpResponse) {
						this.spinnerService.hide();
					}
				}, (error) => {this.spinnerService.hide();}
			));
		}

		return next.handle(req);
	}
}
